import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { memo, useEffect, useRef, useState } from 'react';
import { DateRange, DateRangePicker } from 'react-date-range';
import { format } from 'date-fns';
import vi from 'date-fns/locale/vi';
import Popup from '../Popup';
import Input from '../Input';
// main css file
import Button from '../Button';
import { theme } from '../Theme';

var DateRangeInput = function (props) {
  var onChange = props.onChange,
      value = props.value,
      loading = props.loading,
      helperText = props.helperText,
      error = props.error,
      label = props.label,
      placeholder = props.placeholder,
      inputProps = props.inputProps,
      popupProps = props.popupProps,
      _props$dateFormat = props.dateFormat,
      dateFormat = _props$dateFormat === void 0 ? 'yyyy-MM-dd' : _props$dateFormat,
      hideDefinedRange = props.hideDefinedRange,
      fullWidth = props.fullWidth,
      restProps = _objectWithoutPropertiesLoose(props, ["onChange", "value", "loading", "helperText", "error", "label", "placeholder", "inputProps", "popupProps", "dateFormat", "hideDefinedRange", "fullWidth"]);

  var popupRef = useRef();
  var Picker = hideDefinedRange ? DateRange : DateRangePicker;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
  }),
      state = _useState2[0],
      setState = _useState2[1];

  var getDateFormat = function (date) {
    return format(date, dateFormat);
  };

  useEffect(function () {
    var _ref = value || [],
        startDate = _ref[0],
        endDate = _ref[1];

    if (startDate && endDate) setState({
      startDate: new Date(startDate),
      endDate: new Date(endDate),
      key: 'selection'
    });
  }, [value]);
  useEffect(function () {
    var startDate = state.startDate,
        endDate = state.endDate;
    setInputValue(getDateFormat(startDate) + " - " + getDateFormat(endDate));
  }, [state]);

  var closePicker = function () {
    var _popupRef$current;

    // @ts-ignore
    (_popupRef$current = popupRef.current) == null ? void 0 : _popupRef$current.close();
  };

  return /*#__PURE__*/React.createElement(Popup, _extends({}, popupProps, {
    button: /*#__PURE__*/React.createElement(Input, _extends({
      style: {
        minWidth: 200
      },
      value: inputValue,
      loading: loading,
      helperText: helperText,
      error: error,
      label: label,
      placeholder: placeholder,
      fullWidth: fullWidth
    }, inputProps)),
    ref: popupRef
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Picker, _extends({
    locale: vi,
    onChange: function (item) {
      // @ts-ignore
      setState(item == null ? void 0 : item.selection);
    },
    showSelectionPreview: true,
    moveRangeOnFirstSelection: false,
    months: 2,
    direction: "horizontal",
    ranges: [state],
    rangeColors: [theme.colors.primaryColor]
  }, restProps)), /*#__PURE__*/React.createElement("div", {
    className: "submitButton"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "danger",
    simple: true,
    onClick: closePicker
  }, "Close"), /*#__PURE__*/React.createElement(Button, {
    color: "success",
    onClick: function handleSubmit() {
      var startDate = state.startDate,
          endDate = state.endDate;

      if (startDate && endDate) {
        onChange == null ? void 0 : onChange([startDate.getTime(), endDate.getTime()]);
      }

      closePicker();
    }
  }, "Submit"))));
};

export default /*#__PURE__*/memo(DateRangeInput);